import { useState, useEffect } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

import * as apiComms from '../apiComms';
import * as logger from '../logger';
import * as dayjs from 'dayjs'

const PROG = 'ChartLoyaltySignupsPerDay.js';

const ChartLoyaltySignupsPerDay = (props) => {

  const [chartData, setChartData] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    const loadChartData = async () => {
      const FUNCTION = 'loadChartData';
      try {
        setIsLoadingData(true);
        const _chartDataResponse = await apiComms.getChartDataLoyaltySignupsPerDay(props.timeRange);
        if (_chartDataResponse && !_chartDataResponse.isErr) {
          const _chartData = _chartDataResponse.response.chartdata;
          const _chartDataDateParsed = _parseChartDataDates(_chartData);
          setChartData(_chartDataDateParsed);
        }
        setIsLoadingData(false);
      }
      catch (e) {
        logger.error('Exception Occured', { PROG, FUNCTION });
        console.log('Exception: '+e+', '+e.stack);
      }
    };

    loadChartData();
  }, [props.timeRange]);

  const _parseChartDataDates = (_chartData) => {
    let _parsedChartData = [];
    _chartData.forEach((_chartDataRec) => {
      const _chartDateEpoch = (_chartDataRec.x*1000);
      const _chartDateDayJs = dayjs(_chartDateEpoch);
      const _chartDateReadable = _chartDateDayJs.format('DD/MMM/YYYY');
      _parsedChartData.push({
        date : _chartDateReadable,
        signups : _chartDataRec.y
      });
    });

    return _parsedChartData;
  };

  return (
    <div className='card'>
      <div style={{ display : 'flex', width : '100%', flexDirection : 'column', borderRadius: 10, overflow : 'hidden' }} >
        <div style={{ height : 240 }}>
          {!isLoadingData ? (
            <>
            {Array.isArray(chartData) && chartData.length > 0 ? (
            <ResponsiveContainer>
              <LineChart
                data={chartData}
                margin={{ top: 20, right: 10, left: 6, bottom: 0 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="date"
                  angle={45}
                  textAnchor="start"
                  height={60}
                  tick={{ fontSize: 10 }}
                />
                <YAxis width={42} />
                <Tooltip />
                <Line type="monotone" dataKey="signups" stroke="#20c997" strokeWidth={2} dot={false} />
              </LineChart>
            </ResponsiveContainer>
            ) : null }
            </>
          ) : null }
        </div>
        <div className='card-body'>
          New Loyalty App Sign-Ups Per Day
        </div>
      </div>
    </div>
  );
};

export default ChartLoyaltySignupsPerDay;
